<template>
    <div class="BookBox">
        <div class="book-container" :class="{ initChat: !visible }">
            <div class="header-action">
                <div class="close" @click="close"></div>
            </div>
            <div class="title">{{ title }}</div>
            <div class="tips">
                <div class="tip">
                    <div class="iconfont iconfont1 icon-SHU-1"></div>
                    {{ queryFilter.total }}本书籍
                </div>
                <div class="tip">
                    <div class="iconfont iconfont1 icon-YE-1"></div>
                    {{ pageCount }}个相关页面
                </div>
            </div>
            <div class="search">
                <el-input placeholder="搜索书籍名称" v-model="queryFilter.search" @keyup.enter="search">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    <el-button slot="append" @click="search" type="primary"
                        style="color: #fff;border-radius: 0px 4px 4px 0px;">搜索</el-button>
                </el-input>
            </div>
            <div class="books" ref="books">
                <div v-for="(item, index) in lists" :key="index">
                    <div class="book">
                        <div class="book-left">
                            <img :src="item.coverImg" alt="">
                        </div>
                        <div class="book-right">
                            <div class="book-header">
                                <div class="book-title">{{ item.textbookName }}</div>
                                <div class="book-chapter-count">{{ item.textbookChapterItems.length }}个章节</div>
                            </div>
                            <div class="book-chapters">
                                <div class="book-chapter" v-for="(chapter, chapterIndex) in visibleData(item)"
                                    :key="chapterIndex">
                                    <div class="book-chapter-top">
                                        <div class="name" title="">{{ chapter.chapterName }}</div>
                                        <span class="page">P{{ chapter.page }}</span>
                                    </div>
                                    <div class="book-chapter-link" @click="viewChapter(item, chapter)">查看</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="expandBtn" v-if="item.textbookChapterItems.length > 3">
                        <el-button type="text" @click="toggleExpanded(item)">
                            <i class="iconfont icon-shuangjiantouxiangxia"
                                :class="{ 'rotate-180': item.showMore }"></i>{{ item.showMore ? '收起' : '展开' }}
                        </el-button>
                    </div>
                </div>
            </div>
            <div class="t-pagination">
                <el-button @click="GetChapterLabelTextbooks" :v-loading="isLoading" :disabled="text == '暂无更多数据'">
                    {{ text }}
                </el-button>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'BookBox',
    props: {
        // productId: {require : true}
    },
    data() {
        return {
            visible: false,
            title: '',
            queryFilter: {
                pageIndex: 0,
                pageRows: 3,
                total: 0
            },
            isLoading: false,
            lists: [],
            text: '加载更多',
            pageCount: 0
        }
    },
    watch: {
        $route(route) {
            if (route.path.indexOf('/course/courseDetails') == -1) {
                this.close()
            }
        }
    },
    mounted() {
        this.userId = JSON.parse(localStorage.getItem("vuex")).userInfo.userId
        this.userName = JSON.parse(localStorage.getItem("vuex")).userInfo.nickName
        this.headImg = JSON.parse(localStorage.getItem("vuex")).userInfo.headImge || require('@/static/teacher.png')
    },
    methods: {
        search() {
            this.queryFilter.pageIndex = 0
            this.GetChapterLabelTextbooks()
        },
        visibleData(item) {
            if (item.textbookChapterItems && item.textbookChapterItems.length > 0) {
                return item.showMore ? item.textbookChapterItems : item.textbookChapterItems.slice(0, 3)
            } else {
                return []
            }
        },
        toggleExpanded(item) {
            item.showMore = !item.showMore
        },
        close() {
            this.visible = false
        },
        GetChapterLabelTextbooks() {
            this.isLoading = true;
            this.queryFilter.pageIndex++
            this.$request.post(`course/getChapterLabelTextbooks`, this.queryFilter).then(res => {
                if (res.succeeded) {
                    let list = res.data.data.map(item => {
                        item.showMore === item.textbookChapterItems.length > 3
                        return item
                    });
                    if (this.queryFilter.pageIndex === 1) {
                        this.lists = list
                    } else {
                        this.lists = this.lists.concat(list)
                    }
                    this.queryFilter.total = res.data.total
                    this.pageCount = res.data.extendField || 0
                    if (this.queryFilter.total <= this.queryFilter.pageIndex * this.queryFilter.pageRows) {
                        this.text = '暂无更多数据'
                    } else {
                        this.text = '加载更多'
                    }
                    this.$nextTick(() => {
                        this.$refs.books?.scrollTo(0, this.$refs.books.scrollHeight);
                    });
                }
                this.isLoading = false;
            })
        },
        openBox(data) {
            this.visible = true
            this.queryFilter = {
                pageIndex: 0,
                pageRows: 3,
                total: 0
            }
            this.queryFilter.labelId = data.id
            this.title = data.content
            if (!data.id && data.content) {
                this.queryFilter.keyPoint = data.content
            }
            this.GetChapterLabelTextbooks()
        },
        viewChapter(item, chapter) {
            const role = this.$store.state.userInfo ? this.$store.state.userInfo.role : null;
            const isStudent = role == 1 || (this.$route && this.$route.path && this.$route.path.startsWith('/student'));
            const basePath = isStudent ? '/student/adjunct/adjunctDetails' : '/teacher/adjunct/adjunctDetails';
            this.$openUrl(`${basePath}?courseId=${item.textbookId}&page=${chapter.page}`, '_blank');
        }
       }
    }
</script>

<style scoped lang="scss">
		.book-container {
    position: fixed;
    z-index: 1033;
    width: 704px;
    right: 0;
    top: 0;
    height: 100vh;
    background-color: #FFFFFF;
    box-shadow: 0px 1px 7px 1px rgba(13, 104, 255, 0.35);
    transition: transform 0.3s ease-in-out;
    padding: 0 30px;
    box-sizing: border-box;

    .header-action {
        position: absolute;
        right: 4%;
        display: flex;
        justify-content: flex-end;
        padding-top: 1.5vh;
        width: 96%;
        background: #fff;

        >div {
            width: 1.49vh;
            height: 1.49vh;
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            cursor: pointer;
        }

        .close {
            background-image: url('@/assets/images/ai/close.png');
        }
    }

    .title {
        margin-top: 30px;
        font-size: 22px;
        font-weight: bold;
    }

    .tips {
        display: flex;
        margin-top: 10px;
        align-items: center;
        margin-bottom: 15px;

        .tip {
            color: #313131;
            display: flex;
            margin-right: 35px;
            align-items: center;

            .iconfont1 {
                background: #F0F0F0;
                font-size: 20px;
                border-radius: 4px;
                margin-right: 4px;
            }
        }
    }

    .search {
        margin: 0 auto;
    }

    .books {
        margin-bottom: 10px;
        max-height: calc(100vh - 210px);
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #DBDBDB;
            border-radius: 10px;
        }

        .book {
            display: flex;
            margin-top: 10px;
            padding: 12px 15px;
            background: #EFEFEF;
            border-radius: 16px 16px 16px 16px;
            box-sizing: border-box;

            &-left {
                margin-right: 15px;

                img {
                    width: 125px;
                    height: 172px;
                    border-radius: 7px 7px 7px 7px;
                }
            }

            &-right {
                flex: 1;

                .book-header {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 8px;
                    align-items: center;

                    .book-title {
                        font-size: 16px;
                        font-weight: bold;
                    }

                    .book-chapter-count {
                        color: #666666;
                        font-weight: 14px;
                    }
                }

                .book-chapters {
                    .book-chapter {
                        margin-top: 10px;
                        background: #FFFFFF;
                        display: flex;
                        justify-content: space-between;
                        padding: 5px 10px;
                        border-radius: 4px 4px 4px 4px;
                        border: 1px solid rgba(0, 75, 255, 0.02);
                        align-items: center;

                        &-top {
                            font-size: 14px;
                            display: flex;

                            .name {
                                width: 330px;
                                white-space: nowrap;
                                /* 防止文本换行 */
                                overflow: hidden;
                                /* 隐藏溢出的内容 */
                                text-overflow: ellipsis;
                                /* 显示省略号 */
                            }

                            .page {
                                color: #666666;
                                display: inline-block;
                                margin-left: 10px;
                            }
                        }

                        &-link {
                            padding: 5px 16px;
                            background: #0D68FF;
                            border-radius: 4px 4px 4px 4px;
                            color: #fff;
                            font-size: 14px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }

        .expandBtn {
            background-color: rgba(13, 104, 255, .1);
            width: 120px;
            height: 32px;
            border-radius: 0px 0px 15px 15px;
            margin: 0 auto;
            text-align: center;

            .el-button {
                padding: 6px 15px;
                color: #0D68FF;
            }

            .rotate-180 {
                display: inline-block;
                /* 必须，否则旋转无效 */
                transform: rotate(180deg);
                //   transition: transform 0.3s; /* 可选：添加动画过渡 */
            }
        }
    }

    .t-pagination {
        .el-button {
            background: rgba(13, 104, 255, 0.1);
            border-radius: 4px;
            border: none;
            color: #313131;
            padding: 13px;
            text-align: center;
            font-size: 14px;
            width: 100%;
        }

        .el-button:hover {
            background: rgba(13, 104, 255, 0.1) !important;
            border-radius: 4px !important;
            border: none !important;
            color: #313131 !important;
        }

        .el-button.is-disabled:hover {
            color: #313131;
        }
    }
}

.initChat {
    transform: translateX(110%);
}
</style>